import Vue from 'vue';
import Router from 'vue-router';
// eslint-disable-next-line
import { store } from '@/_store';
import mixpanel from '@/plugins/mixpanel';
// eslint-disable-next-line
import routes from './routes';

/* Override prototype push to avoid errors spamming when redirecting to/from admin/stylist routes */
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => {
    if (Router.isNavigationFailure(err)
      && err?.message.startsWith('Redirected when going from')
      && err?.message.includes('via a navigation guard')) {
      // resolve err
      console.log('Router: Redirected', location);
      return err;
    }
    // rethrow error
    return Promise.reject(err);
  });
};

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/', '/burberry/callback', '/login', '/register', '/salesforce/auth_init', '/salesforce/auth_callback', '/salesforce/oauth_login', '/salesforce/oauth_callback', '/shopify/init_store', '/oauth_outlook_redirect'];
  const authRequired = !publicPages.includes(to.path) && !to.path.startsWith('/password-reset-confirm/') && !to.path.startsWith('/appointment') && !to.path.startsWith('/album/link') && !to.path.startsWith('/assets/link');
  const loggedIn = store.state.account.user;
  const loggedInAsOtherUser = store.getters['account/isSuperuser'];
  const { isAdminMode } = store.state.account;
  const isAdminRoute = to.fullPath.startsWith('/admin');
  // Rules
  if (authRequired && !loggedIn) {
    return next('/login');
  }

  // Mixpanel route tracker
  if (loggedIn) {
    mixpanel.track('navigate', {
      account_id: loggedIn.user.email,
      from: from.path,
      to: to.path,
    });
  }

  /**
   * Admin routes. We know for sure that every /admin route has non-admin route equivalent.
   */
  if (loggedInAsOtherUser && isAdminRoute) {
    store.commit('account/setAdminMode', false);
    return next(to.fullPath.replace(/(^\/admin)(.*$)/g, '$2'));
  }
  // admin route on stylist mode
  const nonAdminRoute = to.fullPath.replace(/(^\/admin)(.*$)/g, '$2');
  if (isAdminRoute && !isAdminMode) {
    console.log('Router: Non-Admin mode navigated to admin route. Redirecting');
    return next(nonAdminRoute);
  }

  const adminRouteExists = router.resolve(`/admin${nonAdminRoute}`).resolved.name !== 'ErrorPage';
  if (isAdminMode && !isAdminRoute && adminRouteExists) {
    console.log('ROUTER: redirecting to admin-mode route');
    return next(`/admin${nonAdminRoute}`);
  }

  return next();
});

export default router;
